<app-action-popup
  [(visible)]="visible"
  (onHidden)="visibleChange.emit(visible)"
  (onShowing)="resetColumnForm()"
  [title]="formCaption"
  (onSave)="save()"
>
  <app-matrix-column-form
    [(columnFormData)]="columnForm"
    [optionData]="optionData"
  ></app-matrix-column-form>
</app-action-popup>
